export default __webpack_public_path__ + "static/media/Background_00152.efa56695.png";